"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgMail = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M32 15c1.652 0 3 1.348 3 3v12c0 1.652-1.348 3-3 3H16c-1.652 0-3-1.348-3-3V18c0-1.652 1.348-3 3-3h16zm1 4.92l-8.427 5.9a1 1 0 01-1.146 0L15 19.92V30c0 .548.452 1 1 1h16c.548 0 1-.452 1-1V19.92zM32 17H16c-.388 0-.728.227-.893.554L24 23.779l8.893-6.225A1.006 1.006 0 0032 17z",
    id: "mail_svg__a"
  }));
};

var _default = SvgMail;
exports.default = _default;